<template>
  <span
    ref="referenceRef"
    class="relative inline-block"
    :aria-describedby="open ? tooltipId : undefined"
    @mouseenter="show"
    @mouseleave="hide"
    @focusin="show"
    @focusout="hide"
    @keydown.esc.stop="hide"
  >
    <slot />

    <Teleport to="body">
      <Transition
        enter-active-class="transition-opacity ease-out duration-200"
        enter-from-class="opacity-0 scale-95"
        enter-to-class="opacity-100 scale-100"
        leave-active-class="transition-opacity ease-in duration-175"
        leave-from-class="opacity-100 scale-100"
        leave-to-class="opacity-0 scale-95"
      >
        <div
          v-if="open && hasText"
          :id="tooltipId"
          ref="floatingRef"
          role="tooltip"
          class="pointer-events-none absolute z-50 max-w-xs whitespace-normal rounded-md bg-gray-900 px-2 py-1 text-xs text-white shadow-lg"
          :style="floatingStyles"
        >
          <slot name="text">{{ text }}</slot>
        </div>
      </Transition>
    </Teleport>
  </span>
</template>

<script setup lang="ts">
import {
  useFloating,
  offset,
  flip,
  shift,
  type Placement,
} from "@floating-ui/vue"

const props = withDefaults(
  defineProps<{
    text?: string
    placement?: Placement
  }>(),
  {
    text: "",
    placement: "bottom-start",
  }
)

const open = ref(false)
const tooltipId = `tt-${Math.random().toString(36).slice(2, 9)}`
const hasText = computed(() => !!props.text)

const show = () => (open.value = true)
const hide = () => (open.value = false)

const referenceRef = useTemplateRef("referenceRef")
const floatingRef = useTemplateRef("floatingRef")

const { floatingStyles } = useFloating(
  referenceRef,
  floatingRef,
  {
    placement: props.placement,
    middleware: [offset(4), flip(), shift()],
  }
)
</script>
